import { RiskLevelIndicator } from "../riskAreaDialog/riskLevels/riskLevelIndicators";
import { RiskAreaAssessmentLevel } from "../riskAreaDialog/RiskAreaDialog.types";

export interface RiskAreaViewModel {
    id: string;
    name: string;
    responsibleId: string;
    assessmentLevel: RiskAreaAssessmentLevel;
    scale: number;
    appetite: number;
    consequenceLevels: string[];
    probabilityLevels: string[];
    riskLevels: string[];
    riskLevelIndicators: RiskLevelIndicator[];
    matrix: number[][];
    // Scored assessments measured under this area, so the blast radius of editing it is visible from the list.
    assessmentCount: number;
}

// The list resolves the responsible's display name and the assessment level's label client-side (the API
// returns only the id and the enum), so those columns can sort by their text like the other columns.
export interface RiskAreaRow extends RiskAreaViewModel {
    responsibleName: string;
    assessmentLevelName: string;
}

export enum PredefinedRiskArea {
    Gdpr = 1,
    Nis2 = 2,
    AiAct = 3,
    InformationSecurity = 4,
}

export interface PredefinedRiskAreaViewModel {
    key: PredefinedRiskArea;
    name: string;
    isAdded: boolean;
}
